import React, { useEffect, useContext } from 'react';

// styling
import '../../Styles/MainPage.scss';

// To push browser history
import { useHistory } from 'react-router-dom';

// Importing components
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Main from './Main';
import HelpfulMessage from './HelpfulMessage';

// global state
import { StateContext, StateDispatchContext } from '../../AppStateContext';

// Access query string
import queryString from 'query-string';

// Font
import alegreyaTTF from '../../fonts/Alegreya-Regular.ttf';

// getUserToken function - makes API request
import { handleConsoleComponentUseEffect } from '../../helperFunctions';

// Material UI stuff
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import { MainPageUseStyles } from '../../Styles/MainPageUseStyles';
import CssBaseline from '@material-ui/core/CssBaseline';

// Material UI Styling
const useStyles = makeStyles((theme) => MainPageUseStyles(theme));

const Console = ({ location }) => {
  // For styling from Material UI
  const classes = useStyles();

  // To consume global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  //to consume browser history
  const history = useHistory();

  // For fetching user token
  const queryCode = queryString.parse(location.hash);
  useEffect(() => {
    handleConsoleComponentUseEffect(setState, queryCode, state, history);

    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Font set up
  const alegreya = {
    fontFamily: 'Alegreya',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
      url(${alegreyaTTF}) format('ttf')
    `,
    unicodeRange:
      'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
  };
  const fontTheme = createTheme({
    typography: {
      fontFamily: 'Alegreya, serif',
      fontSize: 18,
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': [alegreya],
        },
      },
    },
  });

  if (!state.isLoggedIn && queryCode.graphql_query === undefined) {
    return <HelpfulMessage />;
  } else {
    return (
      <ThemeProvider theme={fontTheme}>
        <div className='__MainPage'>
          <CssBaseline />
          <Navbar classes={classes} />
          <Sidebar classes={classes} />
          <Main classes={classes} />
        </div>
      </ThemeProvider>
    );
  }
};

export default Console;
